import classnames from "classnames";
import React from "react";
import ResetState from "./resetstate";
import { INPUT_LIMITS } from "../input-limits";

function TextInput({
  label,
  value,
  onChange,
  className,
  placeholder = "",
  resetValue,
  isResetVisible = true,
  white = false,
  labelClassName,
  minLength,
  maxLength,
  type = "text",
  required = false,
  disabled = false,
  ...inputProps
}) {
  const handleTextChange = (e) => {
    onChange(e);
  };

  if (value === undefined || value === null) {
    value = "";
  }

  const classes = classnames(
    "grigora-text-input text-grigora-base mb-2 flex flex-col justify-between gap-[4px] select-none",
    className,
  );

  const inputClasses = classnames(
    "w-full bg-transparent outline-0 focus-visible:outline-none",
    {
      "opacity-50": disabled,
    },
  );

  const inputContainerClasses = classnames(
    "editor-input-box w-full flex items-center ",
    {
      "bg-white": white,
      "opacity-75": disabled,
    },
  );

  return (
    <div className={classes}>
      {label && (
        <div className=" flex justify-between">
          <label className={labelClassName}>{label && label}</label>
          {isResetVisible && (
            <ResetState
              active={
                value !== "" && value !== undefined && value !== resetValue
              }
              onClick={(e) => {
                onChange({ target: { value: resetValue } });
              }}
            />
          )}
        </div>
      )}
      <div className={inputContainerClasses}>
        <input
          type={type}
          value={value}
          onChange={handleTextChange}
          placeholder={placeholder}
          className={inputClasses}
          required={required}
          disabled={disabled}
          minLength={
            minLength ? minLength : INPUT_LIMITS["default-text-input"].minlength
          }
          maxLength={
            maxLength ? maxLength : INPUT_LIMITS["default-text-input"].maxlength
          }
          {...inputProps}
        />
      </div>
    </div>
  );
}

export default TextInput;
